/* eslint-disable no-console */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import { AutoSizer, Column, SortDirection, Table } from 'react-virtualized';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';

import config from "../../config/config";
import axios from 'axios';

const styles = theme => ({
  table: {
    fontFamily: theme.typography.fontFamily,
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  tableRow: {
    cursor: 'pointer',
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  tableCell: {
    flex: 1,
  },
  noClick: {
    cursor: 'initial',
  },
});

class MuiVirtualizedTable extends React.PureComponent {


  getRowClassName = ({ index }) => {
    const { classes, rowClassName, onRowClick } = this.props;

    return classNames(classes.tableRow, classes.flexContainer, rowClassName, {
      [classes.tableRowHover]: index !== -1 && onRowClick != null,
    });
  };

  cellRenderer = ({ cellData, columnIndex = null }) => {
    const { columns, classes, rowHeight, onRowClick } = this.props;
    return (
      <TableCell
        component="div"
        className={classNames(classes.tableCell, classes.flexContainer, {
          [classes.noClick]: onRowClick == null,
        })}
        variant="body"
        style={{ height: rowHeight }}
        align={(columnIndex != null && columns[columnIndex].numeric) || false ? 'right' : 'left'}
      >
        {cellData}
      </TableCell>
    );
  };

  headerRenderer = ({ label, columnIndex, dataKey, sortBy, sortDirection }) => {
    const { headerHeight, columns, classes, sort } = this.props;
    const direction = {
      [SortDirection.ASC]: 'asc',
      [SortDirection.DESC]: 'desc',
    };

    const inner =
      !columns[columnIndex].disableSort && sort != null ? (
        <TableSortLabel active={dataKey === sortBy} direction={direction[sortDirection]}>
          {label}
        </TableSortLabel>
      ) : (
        label
      );

    return (
      <TableCell
        component="div"
        className={classNames(classes.tableCell, classes.flexContainer, classes.noClick)}
        variant="head"
        style={{ height: headerHeight }}
        align={columns[columnIndex].numeric || false ? 'right' : 'left'}
      >
        {inner}
      </TableCell>
    );
  };



  render() {
    const { classes, columns, ...tableProps } = this.props;
    return (
      <AutoSizer>
        {({ height, width }) => (
          <Table
            className={classes.table}
            height={height}
            width={width}
            {...tableProps}
            rowClassName={this.getRowClassName}
          >
            {columns.map(({ cellContentRenderer = null, className, dataKey, ...other }, index) => {
              let renderer;
              if (cellContentRenderer != null) {
                renderer = cellRendererProps =>
                  this.cellRenderer({
                    cellData: cellContentRenderer(cellRendererProps),
                    columnIndex: index,
                  });
              } else {
                renderer = this.cellRenderer;
              }

              return (
                <Column
                  key={dataKey}
                  headerRenderer={headerProps =>
                    this.headerRenderer({
                      ...headerProps,
                      columnIndex: index,
                    })
                  }
                  className={classNames(classes.flexContainer, className)}
                  cellRenderer={renderer}
                  dataKey={dataKey}
                  {...other}
                />
              );
            })}
          </Table>
        )}
      </AutoSizer>
    );
  }
}

MuiVirtualizedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      cellContentRenderer: PropTypes.func,
      dataKey: PropTypes.string.isRequired,
      width: PropTypes.number.isRequired,
    }),
  ).isRequired,
  headerHeight: PropTypes.number,
  onRowClick: PropTypes.func,
  rowClassName: PropTypes.string,
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  sort: PropTypes.func,
};

MuiVirtualizedTable.defaultProps = {
  headerHeight: 56,
  rowHeight: 56,
};



const WrappedVirtualizedTable = withStyles(styles)(MuiVirtualizedTable);

const data = [
  ['Frozen yoghurt', 159, 6.0, 24, 4.0],
  ['Ice cream sandwich', 237, 9.0, 37, 4.3],
  ['Eclair', 262, 16.0, 24, 6.0],
  ['Cupcake', 305, 3.7, 67, 4.3],
  ['Gingerbread', 356, 16.0, 49, 3.9],
];

let id = 0;

const rows = [
    {alert: "Duplicate PO", number: 15},
    {alert: "Conflict Of Interest", number: 20},
    {alert: "Duplicate Address", number: 5},
];

class dashboardAlertTab extends React.Component {

    state = {
        rows:[]
    }


    handleRowClick = (event) =>{
        console.log(event.rowData.alert)
        this.props.history.push('/'+event.rowData.routine.toLowerCase().replace(/\s/g,''))
    };

    componentDidMount(){
        axios.get(config.allAlerts).then(res => {
            let unique = [...new Set(res.data.map(item => item.name))];
            for (let key in unique){
                var result = res.data.filter(obj => {
                  return obj.name === unique[key]
                })
                let rowsObj = {
                    routine: unique[key],
                    number: result.length
                }
                this.setState(state => {this.state.rows.push(rowsObj)},()=>{console.log(this.state.rows); this.forceUpdate();});
            }
/*            let rows = {
                routine: res.data.routine, 
                number: res.data.items.length
            }
            console.log(rows)
            this.setState(()=>{this.state.rows.push(rows)})*/
        })
    }

    render(){
      console.log(this.state.rows)
      return (
          <Grid container style={{paddingTop:"3px"}}>
              <Paper style={{ height: "65vh", width: '50%'}}>
                <WrappedVirtualizedTable
                  rowCount={this.state.rows.length}
                  rowGetter={({ index }) => this.state.rows[index]}
                  onRowClick={event => {this.handleRowClick(event)}}
                  columns={[
                    {
                      width: 200,
                      flexGrow: 1.0,
                      label: 'Alert',
                      dataKey: 'routine',
                    },
                    {
                      width: 120,
                      label: 'Number',
                      dataKey: 'number',
                      numeric: true,
                    }
                  ]}
                />
              </Paper>
              {this.props.piechart}
        </Grid>
      );
    }
}

export default withRouter(dashboardAlertTab);


// WEBPACK FOOTER //
// ./src/components/Dashboard/dashboard_alerts_tab.js